import { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { ArrowLeft, Award, Baby, Briefcase, Building, CheckCircle, ChevronLeft, ChevronRight, Clock, CreditCard, GraduationCap, Languages, Mail, MapPin, Phone, User, UserCheck } from "lucide-react";
import { datePickerStyles } from "../constants/styles";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog"
import { getCandidateById, submitApplicationFromAssignment } from "../../services/candidateapi";
import toast from "react-hot-toast";
import { getStatusBadgeColor } from "../utils/application.utils";
import { Badge } from "../ui/badge"
import { Label } from "../ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { createApproach, createApproachFromAssignments, getApproachApiErrorMessage, isBlockedPhoneError } from "../../services/approachesapi";
import CallbackModal from "../CallbackModal";
import BlockedPhonePopup from "../BlockedPhonePopup";
import { X } from "lucide-react";
import { cn } from '../lib/utils';
import { getJobs } from "../../services/jobsapi";


export const Table = ({
    headers,
    list,
    setList,
    pagination,
    setPagination,
    user,
    onSearch,
    isLoading,
}) => {
    const navigate = useNavigate();


    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDateFrom, setSelectedDateFrom] = useState("");
    const [selectedDateTo, setSelectedDateTo] = useState("")

    const [paginationData, setPaginationData] = useState({
        page: pagination?.page,
        limit: pagination?.limit,
        totalResults: pagination?.totalResults,
        totalPages: Math.ceil(pagination?.totalResults / pagination.limit),
    });

    const statusOptions = useMemo(
        // 'Ringing Not Reachable', 'Not Reachable', 'Not Interested',"Interested", 'Call Back', 'Schedule', 'Not Relevant'
        () => [ 
            { value: "Ringing Not Reachable", label: "Ringing Not Reachable" },
            { value: "Not Reachable", label: "Not Reachable" },
            { value: "Not Interested", label: "Not Interested" },
            { value: "Interested", label: "Interested" },
            { value: "Call Back", label: "Call Back" },
            { value: "Schedule", label: "Schedule" },
            { value: "Not Relevant", label: "Not Relevant" },
            { value: "Salary Issue", label: "Salary Issue" },
            { value: "Incorrect Number", label: "Incorrect Number" },
            { value: "DND", label: "DND" },

        ],
        []
    )
    const [showCandidateDetailsModal, setShowCandidateDetailsModal] = useState(false)
    const [isLoadingDetails, setIslloadingDetails] = useState(false)
    const [detailsError, setDetailsError] = useState(null)
    const [openCallBackModal, setOpenCallBackModal] = useState(false)
    const [selected, setSelected] = useState(null)
    const [pendingPayload, setPendingPayload] = useState({});
    const [loadingJobModal, setLoadingJobModal] = useState(false)
    const [selectedCandidateForDetails, setSelectedCandidateForDetails] = useState()
    const [selectedIdForCallBack, setSelectedIdForCallBack] = useState(null);

    const [openJobSelectionModal, setOpenJobSelectionModal] = useState(false)
    const [selectedJobId, setSelectedJobId] = useState()
    const [jobSearchValue, setJobSearchValue] = useState("")
    const [loadingModal, setLoadingModal] = useState(false)
    const [assignedJobs, setAssignedJobs] = useState([])
    const [blockedPopupOpen, setBlockedPopupOpen] = useState(false)
    const [blockedPopupMessage, setBlockedPopupMessage] = useState("")

    const searchTimeout = useRef(null);

    useEffect(() => {
        setPaginationData({
            page: pagination.page,
            limit: pagination.limit,
            totalResults: pagination.totalResults,
            totalPages: Math.ceil(pagination.totalResults / pagination.limit) || 1,
        });
    }, [pagination]);

    // Inject datepicker styles
    useEffect(() => {
        if (typeof document !== "undefined" && datePickerStyles) {
            const styleSheet = document.createElement("style");
            styleSheet.innerText = datePickerStyles;
            document.head.appendChild(styleSheet);
            return () =>
                document.head.contains(styleSheet) &&
                document.head.removeChild(styleSheet);
        }
    }, []);
    useEffect(() => {
        async function getAlljobs() {
            const jobs = await getJobs();
            return jobs.data;
        }

        if (openJobSelectionModal) {
            // Call the async function and await its result
            document.body.style.overflow = "hidden";
            setLoadingModal(true)
            getAlljobs().then((assigned) => {
                setLoadingModal(false)
                setAssignedJobs(assigned.jobs)
            }).catch((err) => {
                setLoadingModal(false)
                console.error(err)
            });
        } else {
            setLoadingModal(false)
            document.body.style.overflow = "auto";
        }
    }, [openJobSelectionModal]);

    const triggerSearch = (term, from, to) => {
        if (searchTimeout.current) clearTimeout(searchTimeout.current);

        searchTimeout.current = setTimeout(() => {
            onSearch(term, from, to);
        }, 500);
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        triggerSearch(value, selectedDateFrom, selectedDateTo);
    };

    const handleDateFromChange = (e) => {
        const value = e.target.value;
        setSelectedDateFrom(value);
        triggerSearch(searchTerm, value, selectedDateTo);
    };

    const handleDateToChange = (e) => {
        const value = e.target.value;
        setSelectedDateTo(value);
        triggerSearch(searchTerm, selectedDateFrom, value);
    };

    const handleCandidateNameClick = async (app) => {
        setShowCandidateDetailsModal(true)
        console.log("l", app)
        try {
            const response = await getCandidateById(app.candidateId)
            if (!response?.data?.candidate) {
                throw new Error("No candidate data returned from API")
            }
            const candidate = response.data.candidate
            setSelectedCandidateForDetails(candidate)
        } catch (err) {
            // setDetailsError(err.message || "Failed to fetch candidate details")
            toast.error(err.message || "Failed to fetch candidate details", {
                duration: 4000,
            })
        }
    }

    const handleUpdateStatus = async (obj) => {
        console.log(obj.value)
        try {
            const payload = {
                assignedJobId: obj._id,
                name: obj.candidateName,
                phone: obj.candidatePhone,
                email: obj.candidateEmail,
                qualifications: obj.canidateQualification,
                source: "EarlyJobs",
                callStatus: obj.value,
                jobId: obj.jobId,
            }
            if (obj.value === "Call Back") {
                setOpenCallBackModal(true)
                setPendingPayload(payload)
                setSelectedIdForCallBack(obj._id)
            }
            else if (obj.value === "Schedule") {
                setOpenJobSelectionModal(true)
                setPendingPayload(payload)
                setSelected(obj._id)

            } else {
                await createApproachFromAssignments(payload)
                toast.success("status changed successfully")

                 setList((prev) => prev.filter((item) => item._id !== obj._id));

            }
        } catch (error) {
            console.log(error)
            if (isBlockedPhoneError(error)) {
                setBlockedPopupMessage(getApproachApiErrorMessage(error))
                setBlockedPopupOpen(true)
            } else {
                toast.error("Something went wrong")
            }
        }
    }


    const handleUpdateStatusforCallBack = async (date, time) => {
        try {
            const payload = {
                ...pendingPayload,
                callBackTime: date + "T" + time
            }
            console.log("payloasds", JSON.stringify(payload))
            await createApproachFromAssignments(payload)
            toast.success("status changed successfully")

            setList((prev) => prev.filter((item) => item._id !== selectedIdForCallBack));
        } catch (error) {
            console.log(error)
            if (isBlockedPhoneError(error)) {
                setBlockedPopupMessage(getApproachApiErrorMessage(error))
                setBlockedPopupOpen(true)
            } else {
                toast.error("Something went wrong")
            }
        }
    }

    const SortableHeader = ({ children }) => (
        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sticky top-0 bg-[#FFF5F2] z-10 cursor-pointer hover:bg-gray-100">
            {children}
        </th>
    );

    const handleJobSearchChange = (e) => {
        const value = e.target.value;
        setSelectedJobId("")
        setJobSearchValue(value);

        // Clear previous timeout
        if (searchTimeout.current) clearTimeout(searchTimeout.current);

        // Set new timeout
        searchTimeout.current = setTimeout(async () => {
            setLoadingModal(true)
            await getJobs({ page: 1, limit: 100, search: value }).then(jobs => {
                setLoadingModal(false)
                setAssignedJobs(jobs.data.jobs)
            });
        }, 1500);
    };

    const handleAccept = async () => {
        try {
            const payload = {
                _id: selected,
                jobId: selectedJobId
            }
            await submitApplicationFromAssignment(payload)
            await createApproachFromAssignments(pendingPayload)
            toast.success(`Application accepted!`)
            setOpenJobSelectionModal(false)
            setTimeout(()=>{
                setList((prev) => prev.filter((item) => item._id !== selected));
            },1000)
              


        } catch (error) {

            if (error.response?.status === 409) {
                toast.error("This application already exists or is duplicated.");
            } else {
                console.log(error)
                toast.error(error.response?.data?.message || "Something went wrong");
            }
        }
    };

    return (
        <div className="flex flex-col h-screen bg-white border border-gray-200 rounded-lg">
            {/* Header + Search */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between p-4 gap-3 border-b border-gray-200">
                <div className="flex items-center gap-2">
                    <Button
                        variant="ghost"
                        size="sm"
                        className="p-1"
                        onClick={() => navigate(-1)}
                    >
                        <ArrowLeft className="w-4 h-4" />
                    </Button>
                    <div>
                        <h1 className="text-lg sm:text-xl font-semibold text-gray-900">
                            Assigned Job List
                        </h1>
                        <p className="text-xs sm:text-sm text-gray-500">
                            View and manage assigned jobs
                        </p>
                    </div>
                </div>

                <div className="flex flex-wrap gap-2 items-center">
                    <Input
                        placeholder="Search list..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="pl-10 w-full sm:w-64 border-gray-300"
                    />
                    <Input
                        type="date"
                        value={selectedDateFrom}
                        onChange={handleDateFromChange}
                        className="w-full sm:w-40 h-10 rounded-lg border-gray-200 focus:ring-2 focus:ring-orange-500"
                        title="From Date"
                    />
                    <Input
                        type="date"
                        value={selectedDateTo}
                        onChange={handleDateToChange}
                        className="w-full sm:w-40 h-10 rounded-lg border-gray-200 focus:ring-2 focus:ring-orange-500"
                        title="To Date"
                    />
                </div>
            </div>

            {/* Table */}
            <div className="flex-1 overflow-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead>
                        <tr>
                            {headers.map((header, i) => (
                                <SortableHeader key={i}>{header}</SortableHeader>
                            ))}
                            <th className="px-4 py-3 sticky top-0 bg-[#FFF5F2] z-10"></th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {isLoading ? (
                            // 🔸 Skeleton rows
                            Array.from({ length: 15 }).map((_, i) => (
                                <tr key={i} className="animate-pulse">

                                    <td className="px-4 py-4">
                                        <div className="h-4 bg-gray-200 rounded w-3/5"></div>
                                    </td>
                                    <td className="px-4 py-4">
                                        <div className="h-4 bg-gray-200 rounded w-3/5"></div>
                                    </td>
                                    <td className="px-4 py-4">
                                        <div className="h-4 bg-gray-200 rounded w-4/5"></div>
                                    </td>
                                    <td className="px-4 py-4">
                                        <div className="h-4 bg-gray-200 rounded w-2/5"></div>
                                    </td>
                                    <td className="px-4 py-4">
                                        <div className="h-4 bg-gray-200 rounded w-3/6"></div>
                                    </td>
                                    <td className="px-4 py-4">
                                        <div className="h-10 bg-gray-200 rounded w-48"></div>
                                    </td>
                                </tr>
                            ))
                        ) : list?.length > 0 ? (
                            list.map((l) => (
                                <tr
                                    key={l._id}
                                    className="hover:bg-gray-50 transition-colors cursor-pointer"
                                                                 >
                                    <td className="px-4 py-6" onClick={() => handleCandidateNameClick(l)}>{l.candidateName}</td>
                                    <td className="px-4 py-4" onClick={() => handleCandidateNameClick(l)}>{l.candidateEmail || "-"}</td>
                                    <td className="px-4 py-4" onClick={() => handleCandidateNameClick(l)}>{l.location || "-"}</td>
                                    <td className="px-4 py-4" onClick={() => handleCandidateNameClick(l)}>{l.candidatePhone || "-"}</td>
                                    <td className="px-4 py-4" onClick={() => handleCandidateNameClick(l)} >
                                        {new Date(l.createdAt).toLocaleDateString()}
                                    </td>
                                    <td className="px-4 py-4" >
                                        <div className="space-y-2">

                                            <Select onValueChange={(val) => handleUpdateStatus({ ...l, value: val })}>

                                                <SelectTrigger className="h-11 w-48">
                                                    <SelectValue placeholder={l.status} />
                                                </SelectTrigger>
                                                <SelectContent className="w-48">
                                                    {statusOptions.map((option) => (
                                                        <SelectItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </SelectItem>
                                                    ))}
                                                </SelectContent>
                                            </Select>
                                        </div>
                                    </td>
                                    <td className="px-4 py-4"  onClick={() => handleCandidateNameClick(l)}  >
                                        {l.status === "applied" && user?.role !== "ADMIN" && (
                                            <div className="flex gap-2">
                                                <Button size="sm" variant="outline">
                                                    Shortlist
                                                </Button>
                                                <Button size="sm" variant="destructive">
                                                    Reject
                                                </Button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="px-4 py-12 text-center text-gray-500"
                                >
                                    No list found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Sticky Pagination */}
            <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-200 sticky bottom-0 bg-white z-10">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() =>
                        setPagination((p) => ({ ...p, page: Math.max(1, p.page - 1) }))
                    }
                    disabled={pagination.page === 1}
                >
                    <ChevronLeft className="w-4 h-4" />
                </Button>

                {Array.from({ length: paginationData.totalPages }, (_, i) => i + 1).map(
                    (pageNum) => (
                        <Button
                            key={pageNum}
                            variant={
                                paginationData.page === pageNum ? "default" : "outline"
                            }
                            size="sm"
                            onClick={() =>
                                setPagination((p) => ({ ...p, page: pageNum }))
                            }
                            className={
                                paginationData.page === pageNum
                                    ? "bg-orange-600 text-white hover:bg-orange-700"
                                    : ""
                            }
                        >
                            {pageNum}
                        </Button>
                    )
                )}

                <Button
                    variant="outline"
                    size="sm"
                    onClick={() =>
                        setPagination((p) => ({
                            ...p,
                            page: Math.min(
                                paginationData.totalPages,
                                p.page + 1
                            ),
                        }))
                    }
                    disabled={pagination.page === paginationData.totalPages}
                >
                    <ChevronRight className="w-4 h-4" />
                </Button>
            </div>


            <Dialog open={showCandidateDetailsModal} onOpenChange={setShowCandidateDetailsModal}>
                <DialogContent className="max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-5xl max-h-[90vh] overflow-y-auto rounded-2xl sm:rounded-3xl no-scrollbar mx-4 sm:mx-auto">
                    <DialogHeader className="pb-4">
                        <DialogTitle className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 flex flex-col sm:flex-row items-start sm:items-center gap-3">
                            <div className="h-10 w-10 sm:h-12 sm:w-12 bg-orange-600 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
                                {selectedCandidateForDetails?.name.charAt(0).toUpperCase()}
                            </div>
                            <span className="break-words">{selectedCandidateForDetails?.name}</span>
                        </DialogTitle>
                    </DialogHeader>
                    {isLoadingDetails ? (
                        <div className="text-center py-8 sm:py-12">
                            <div className="animate-spin inline-block h-8 w-8 sm:h-10 sm:w-10 border-4 border-orange-600 border-t-transparent rounded-full mb-4"></div>
                            <p className="text-base sm:text-lg text-gray-600">Loading candidate details...</p>
                        </div>
                    ) : detailsError ? (
                        <div className="text-center py-8 sm:py-12">
                            <p className="text-base sm:text-lg text-red-600">{detailsError}</p>
                        </div>
                    ) : selectedCandidateForDetails ? (
                        <div className="space-y-4 sm:space-y-6 p-0">
                            <div className="bg-gradient-to-r from-orange-50 to-indigo-50 rounded-xl p-4 sm:p-6">
                                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                                    <User className="h-4 w-4 sm:h-5 sm:w-5 text-orange-600" />
                                    Basic Information
                                </h3>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                                    <div className="space-y-3">
                                        <div className="flex items-start gap-3">
                                            <Mail className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Email</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base break-words">
                                                    {selectedCandidateForDetails.email}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <Phone className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Phone</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.phone}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <User className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Father's Name</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.fatherName || "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <UserCheck className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Gender</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.gender || "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="space-y-3">
                                        <div className="flex items-start gap-3">
                                            <MapPin className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Location</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.currentLocationDetails?.city || "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <Baby className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Date of Birth</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.dateOfBirth
                                                        ? new Date(selectedCandidateForDetails.dateOfBirth).toLocaleDateString("en-GB")
                                                        : "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <CreditCard className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Aadhar Number</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.aadharNumber || "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="space-y-3">
                                        <div className="flex items-start gap-3">
                                            <GraduationCap className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Highest Qualification</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.highestQualification || "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <Languages className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Spoken Languages</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.spokenLanguages &&
                                                        selectedCandidateForDetails.spokenLanguages.length > 0
                                                        ? selectedCandidateForDetails.spokenLanguages.join(", ")
                                                        : "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <Briefcase className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Experience</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {selectedCandidateForDetails.totalExperienceYears !== undefined &&
                                                        selectedCandidateForDetails.totalExperienceMonths !== undefined
                                                        ? `${selectedCandidateForDetails.totalExperienceYears} years ${selectedCandidateForDetails.totalExperienceMonths} months`
                                                        : "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <Award className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Skills</p>
                                                <div className="flex flex-wrap gap-1 mt-1">
                                                    {Array.isArray(selectedCandidateForDetails.skills) &&
                                                        selectedCandidateForDetails.skills.length > 0 ? (
                                                        selectedCandidateForDetails.skills.slice(0, 3).map((skill, index) => (
                                                            <Badge key={index} variant="secondary" className="text-xs">
                                                                {skill}
                                                            </Badge>

                                                        ))
                                                    ) : (
                                                        <span className="font-medium text-gray-900 text-sm sm:text-base">N/A</span>
                                                    )}
                                                    {Array.isArray(selectedCandidateForDetails.skills) &&
                                                        selectedCandidateForDetails.skills.length > 3 && (
                                                            <Badge variant="secondary" className="text-xs">
                                                                +{selectedCandidateForDetails.skills.length - 3} more
                                                            </Badge>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gradient-to-r from-orange-50 to-indigo-50 rounded-xl p-4 sm:p-6">
                                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                                    <Briefcase className="h-4 w-4 sm:h-5 sm:w-5 text-orange-600" />
                                    Professional Information
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="flex flex-col sm:flex-row sm:justify-between gap-3">
                                        <div className="flex items-start gap-3">
                                            <Building className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Job Category</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {Array.isArray(selectedCandidateForDetails.preferredJobCategories) &&
                                                        selectedCandidateForDetails.preferredJobCategories.length > 0
                                                        ? selectedCandidateForDetails.preferredJobCategories.join(", ")
                                                        : "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <Clock className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs sm:text-sm text-gray-600">Employment Type</p>
                                                <p className="font-medium text-gray-900 text-sm sm:text-base">
                                                    {Array.isArray(selectedCandidateForDetails.preferredEmploymentTypes) &&
                                                        selectedCandidateForDetails.preferredEmploymentTypes.length > 0
                                                        ? selectedCandidateForDetails.preferredEmploymentTypes.join(", ")
                                                        : "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="bg-white border border-gray-200 rounded-xl p-4 sm:p-6">
                                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                                    <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 text-orange-600" />
                                    Application Status
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <p className="text-xs sm:text-sm text-gray-600 mb-2">Current Status</p>
                                        <Badge
                                            className={`${getStatusBadgeColor(applications?.find((app) => app.candidate.id === selectedCandidateForDetails.id)?.currentStatus?.status ?? "")} border font-medium px-3 py-1 text-xs sm:text-sm`}
                                        >
                                            {applications?.find((app) => app.candidate.id === selectedCandidateForDetails.id)?.currentStatus
                                                ?.status ?? "N/A"}
                                        </Badge>
                                    </div>
                                    <div>
                                        <p className="text-xs sm:text-sm text-gray-600 mb-2">Sourced By</p>
                                        <div className="flex items-center gap-2">
                                            <User className="h-4 w-4 text-gray-400" />
                                            <span className="font-medium text-gray-900 text-sm sm:text-base">
                                                {applications.find((app) => app.candidate.id === selectedCandidateForDetails.id)?.sourcedBy
                                                    ?.username ?? "N/A"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    ) : null}
                </DialogContent>
            </Dialog>


            {openJobSelectionModal && <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50" onClick={() => { setOpenJobSelectionModal(false) }} >
                <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 relative" onClick={(e) => e.stopPropagation()} >
                    {/* Close Button */}
                    <button
                        onClick={() => { setOpenJobSelectionModal(false) }}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    {/* Modal Content */}
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Select job to assign</h2>

                    <div className="relative mb-4">
                        <input
                            type="text"
                            placeholder="Search jobs..."
                            className="w-full pl-4 pr-4 py-2 border border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200"
                            value={jobSearchValue}
                            onChange={handleJobSearchChange}
                        />
                    </div>

                    <div className="max-h-64 overflow-y-auto border rounded-lg">
                        {loadingModal ? (
                            <div className="px-4 py-6 text-center text-gray-500">
                                <p className="font-medium">Loading...</p>
                            </div>
                        ) : assignedJobs.length > 0 ? (
                            assignedJobs.map(job => (
                                <div
                                    key={job.id}
                                    className={cn(
                                        "px-4 py-3 cursor-pointer transition-all duration-150 text-gray-900",
                                        selectedJobId === job.id
                                            ? "bg-blue-50 border-r-4 border-blue-500" // selected background
                                            : "hover:bg-gray-50" // default hover background
                                    )}
                                    onClick={() => setSelectedJobId(job.id)}
                                >
                                    <div className="flex items-center space-x-3">
                                        <div className="w-2 h-2 rounded-full bg-gray-300" />
                                        <div className="flex flex-col">
                                            <span className="font-semibold text-gray-900">{job.title}</span>
                                            <span className="text-gray-600 text-sm">{job.companyName}</span>
                                            <span className="text-gray-500 text-sm">{job.location}</span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="px-4 py-6 text-center text-gray-500">
                                <p className="font-medium">No jobs found</p>
                                <p className="text-sm">Try adjusting your search terms</p>
                            </div>
                        )}
                    </div>


                    <div className="flex w-full gap-3 mt-4">
                        {/* Cancel Button */}
                        <Button
                            variant="outline"
                            size="sm"
                            className={cn(
                                "flex-1 rounded-md border border-gray-300 px-3 py-1 text-sm font-medium text-gray-500 bg-white hover:bg-gray-50 justify-center"
                            )}
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedJobId("")
                                setOpenJobSelectionModal(false)
                            }}
                        >
                            Cancel
                        </Button>

                        {/* Select Button */}
                        <Button
                            variant="outline"
                            size="sm"
                            className={cn(
                                "flex-1 rounded-md border border-orange-300 px-3 py-1 text-sm font-medium text-orange-500 bg-white hover:bg-orange-50 justify-center"
                            )}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAccept()
                            }}
                            disabled={!selectedJobId}
                        >
                            Submit
                        </Button>
                    </div>

                </div>

            </div>}


            <CallbackModal isOpen={openCallBackModal} onClose={() => setOpenCallBackModal(false)} onSubmit={(date, time) => {
                handleUpdateStatusforCallBack(date, time)
            }} />
            <BlockedPhonePopup
                open={blockedPopupOpen}
                message={blockedPopupMessage}
                onClose={() => setBlockedPopupOpen(false)}
            />
        </div>
    );
};



